import { getSiteName } from '../SiteConfigs.js';
import { readCookie, setCookie, getCookie, createCookie, eraseCookie, deleteCookie } from '../Utility/CookieManager';

let siteName = getSiteName();

var debug = false;
if( process.env.MIX_NEWSLLETTERS_DEBUG ){
    if(process.env.MIX_NEWSLLETTERS_DEBUG === "true"){
        debug = true;
    }else{
        debug = false;
    }
}

var widget_loc = ''; //SCRIPT LOCATION - WIDGET ITS LOADED FROM - TRACKING PURPOSES
var active_newsletters = {};
active_newsletters.mc_modal_has_been_created = false;
active_newsletters.debug = debug;
active_newsletters.subscribed = {}
active_newsletters.recommended = [];
active_newsletters.user_email; // this will get user's email if you are logged in or not - used for mc embedded form
active_newsletters.preselect_newsletters; // this will get user newsletters if they are logged in or not  - used for mc embedded form
active_newsletters.is_unsubscribed = false; // set user unsubscribed to to false by default
active_newsletters.lists = [
    {
        audience_id: "a4db5f2336", // original audience ID
        test_id: "2751c667e4", // test group interest ID
        id: "0978b16ed7", // prod group interest ID
        name:"Carl M. Cannon's Morning Note",
        site:"politics",
        image : '/asset/img/newsletter_icons/carl_cannon.png',
        excerpt : ' Headlines against the historic events',
        color: '#dc0000'
    },
    {
        audience_id: "51f930c5ce", // original audience ID
        test_id: "8ce6d0f9aa", // test group interest ID
        id: "b6df7a5a47", // prod group interest ID
        name: "RCP Today",
        site:"politics",
        image : "/asset/img/newsletter_icons/rcp_today.png",
        excerpt : 'Top stories on RealClearPolitics',
        color: '#dc0000'
    },

    {
        audience_id: "d6a76c9ec3", // original audience ID
        test_id: "43294146b6", // test group interest ID
        id: "b0e1454bd9", // prod group interest ID
        name : "RCP Takeaway",
        site : 'politics',
        image: "/asset/img/newsletter_icons/rcp_takeaway.png",
        excerpt : 'Examining political events Podcast',
        color: '#dc0000'
    },
    {
        audience_id: "9da46952f0", // original audience ID
        test_id: "bb79f1b917", // test group interest ID
        id: "17b0333591", // prod group interest ID
        name: "RCP Events",
        site:"politics",
        image : "/asset/img/newsletter_icons/calendar.png",
        excerpt:  'Invitations to events around the country',
        color: '#dc0000'
    },
    {
        audience_id: "694f73a8dc", // original audience ID
        test_id: "9d8f4221ba", // test group interest ID
        id: "4be11a1ba6", // prod group interest ID
        name: "Defense Morning Recon",
        site:"defense",
        image: "/asset/img/newsletter_icons/defense.png",
        excerpt: 'Featuring the latest news',
        color: '#485228'
    },
    {
        audience_id: "267b89dc8a", // original audience ID
        test_id: "eeb27ece7f", // test group interest ID
        id: "7c94a2a355", // prod group interest ID
        name: "Science News",
        site:"science",
        image: "/asset/img/newsletter_icons/science.png",
        excerpt: 'Featuring the latest science news',
        color: '#37414A'
    },
    {
        audience_id: "462961a8ae", // original audience ID
        test_id: "cf52b8fa52", // test group interest ID
        id: "698c52111c", // prod group interest ID
        name: "Energy Morning Volt",
        site:"energy",
        image: "/asset/img/newsletter_icons/energy.png",
        excerpt: 'Latest energy news',
        color: '#70AB41'
    },
    {
        audience_id: "d519acabbf", // original audience ID
        test_id: "2b9370f739", // test group interest ID
        id: "131071d6c4", // prod group interest ID
        name: "World News",
        site:"world",
        image: "/asset/img/newsletter_icons/world.png",
        excerpt: 'Featuring the latest world news',
        color: '#0c124d'
    },
    {
        audience_id: "8a051b373b", // original audience ID
        test_id: "a718e5c3d9", // test group interest ID
        id: "a957e8b6b1", // prod group interest ID
        name: "Education Today",
        site:"education",
        image:'/asset/img/newsletter_icons/education.png',
        excerpt: 'Featuring the latest education news',
        color: '#8b0000'
    },
    {
        audience_id: "b4baf6b587", // original audience ID
        test_id: "dacd13e973", // test group interest ID
        id: "834d157b5f", // prod group interest ID
        name: "Health Morning Scan",
        site:"health",
        image: "/asset/img/newsletter_icons/health.png",
        excerpt: 'Featuring the latest health news',
        color: '#dbb706'
    },
    {
        audience_id: "113ee1bc69", // original audience ID
        test_id: "a70af307dd", // test group interest ID
        id: "49df3ce58e", // prod group interest ID
        name: "Policy",
        site:"policy",
        image: "/asset/img/newsletter_icons/policy.png",
        excerpt: 'Featuring the latest policy news',
        color: '#65198E'
    },
    {
        audience_id: "7f0a4512a1", // original audience ID
        test_id: "dc25cbca4f", // test group interest ID
        id: "b54e369263", // prod group interest ID
        name: "Religion Today",
        site:"religion",
        image: "/asset/img/newsletter_icons/religion.png",
        excerpt: 'Featuring the latest religion news',
        color: '#81c0c8'
    },
    {
        audience_id: "ea772b1135", // original audience ID
        test_id: "6b083a4d7f", // test group interest ID
        id: "e1222b54d5", // prod group interest ID
        name: "Books Today",
        site:"books",
        image: "/asset/img/newsletter_icons/books.png",
        excerpt: 'Featuring the latest books news',
        color: '#017ba8'
    },
    {
        audience_id: "fbced764bd", // original audience ID
        test_id: "e8a547edc8", // test group interest ID
        id: "75efb6c7ae", // prod group interest ID
        name: "History Today",
        site:"history",
        image: "/asset/img/newsletter_icons/history.png",
        excerpt: 'Featuring the latest history news',
        color: '#cc6600'
    },
    {
        audience_id: "1f71a1eaa2", // original audience ID
        test_id: "857ccfac05", // test group interest ID
        id: "81822f7ea3", // prod group interest ID
        name: "Markets Today",
        site:"markets",
        image: "/asset/img/newsletter_icons/rcmarkets.png",
        excerpt: 'Featuring the latest markets news',
        color: '#669933'
    },
    {
        audience_id: "d042379c8d", // original audience ID
        test_id: "84c4417a7f", // test group interest ID
        id: "6352181190", // prod group interest ID
        name: "Investigations Today",
        site:"investigations",
        image: "/asset/img/newsletter_icons/investigations.png",
        excerpt: 'Latest investigations news',
        color: '#5d5d5d'
    },
    {
        id: "98754a303f", // prod group interest ID
        name: "Florida Today",
        site:"florida",
        image: "/asset/img/newsletter_icons/florida.png",
        excerpt: 'Featuring the latest florida news',
        color: '#a80534'
    },
    {
        id: "b64a8082f3", // prod group interest ID
        name: "Pennsylvania Today",
        site:"pennsylvania",
        image: "/asset/img/newsletter_icons/pennsylvania.png",
        excerpt: 'Featuring the latest pennsylvania news',
        color: '#002a86'
    }
];
active_newsletters.clicked_newsletter_id = '';
active_newsletters.active_item = '';
active_newsletters.initial_email_used = '';
active_newsletters.beta_widget_enabled = false

active_newsletters.current_site = siteName;
active_newsletters.signup_modal = function (nl_name, nl_color){
    let html = '<div class="active-subscribe-modal"></div>'; // this is what will tigger the overlay

    html +=
        '<div class="newsletter-signup-modal">' +
        '    <i class="close-icon right"></i>' +
        '    <div class="heading">' +
        '        Enter your email address to subscribe to <strong style="background:'+ nl_color +';">'+nl_name+'</strong></div>' +
        '    <div class="sign-up-form">' +
        '        <form class="new-newsletter-sign-up-form" autocomplete="off">' +
        '            <input type="hidden" name="zelda" class="zelda">' +
        '            <div class="inline-group">' +
        '                <label for="user_email">Email Address </label><input id="user_email" type="email" name="email" class="email_address" required>' +
        '                <label for="tos_accept"><input type="checkbox" name="tos_accept" id="tos_accept" required>I agree to the <a target="_blank" href="/privacy.html">Privacy Policy</a> and <a target="_blank" href="/terms_of_service.html">Terms of Service</a></label>   '+
        '                <input type="submit" class="btn btn-submit" value="Subscribe" disabled>' +
        '            </div>' +
        '        </form>' +
        '    </div>' +
        '</div>';

    $('body').append(html);

    this.actionTriggers();
};

active_newsletters.login_option = function (){

    html = '' +
        '<i class="close-icon right"></i>' +
        '    <div class="sub-heading success">You have successfully subscribed to '+ active_newsletters.active_item.attr("data-name") +' </div>'+
        '    <div class="heading">We see you are already a member. Sign in to see all your subscriptions.</div>' +
        '    <div class="user-options">' +
        '        <div class="btn btn-option sign-in-option">' +
        '            Sign In' +
        '        </div>' +
        '        <div class="btn btn-option continue">' +
        '            Close' +
        '        </div>' +
        '    </div>';

    return html;
}

active_newsletters.associated_account_html = function(){

    var html = '' +
        '    <i class="close-icon right"></i>' +
        '    <div class="sub-heading success">' +
        '        <div class="message"> You have successfully subscribed to '+ active_newsletters.active_item.attr("data-name") +'</div>' +
        '        <div class="btn btn-option close-modal">Close window and sign up for more</div>' +
        '    </div>'+
        '    <div class="heading">Sign in to see all your subscriptions.</div>' +
        '    <div class="newsletter-form-sign-in-wrapper">' +
        '      <form name="newsletter-form-sign-in" id="newsletter-form-sign-in" autocomplete="off">' +
        '            <label for="user_email" >Email</label>' +
        '            <input type="email" id="user_email" name="user_email" value="'+ active_newsletters.initial_email_used +'" required >' +
        '            <label for="user_password">Password</label>' +
        '            <input type="password" id="user_password" name="user_password" required>' +
        '            <small class="sign_in_form_errors"></small>'+
        '            <input type="hidden" name="zelda">'+
        '            <input type="submit" value="Login" class="btn-submit">' +
        '        </form>' +
        '    </div>';

    return html;

}

active_newsletters.beta_logged_in_user_filter_subscribed_newsletters = function(){
    if(readCookie('rcmg_newsletters')){

        if(IsJsonString(readCookie('rcmg_newsletters'))){
            active_newsletters.subscribed = JSON.parse(readCookie('rcmg_newsletters'));
            active_newsletters.disable_subscribed_newsletters('beta');
        }

    }
}

active_newsletters.register_account_html = function(){
    var html = '';

    html += ' <i class="close-icon right"></i>' +
        '    <div class="sub-heading success">' +
        '        <div class="message"> You have successfully subscribed to '+ active_newsletters.active_item.attr("data-name") +'</div>' +
        '        <div class="btn btn-option close-modal">Close window and sign up for more</div>' +
        '    </div>'+
        '    <div class="heading">Register a free account to manage your subscriptions.</div>' +
        '    <div class="newsletter-form-register-wrapper">' +
        '        <form name="newsletter-form-register" id="newsletter-form-register" autocomplete="off">' +
        '            <label for="user_full_name" >Full Name</label>' +
        '            <input type="text" name="full_name" id="user_full_name" required>'+
        '            <label for="user_email" >Email</label>' +
        '            <input type="email" id="user_email" name="user_email" value="'+ active_newsletters.initial_email_used +'" required >' +
        '            <label for="user_password">Password</label>' +
        '            <input type="password" id="user_password" name="user_password" required>' +
        '            <label for="user_password">Confirm Password</label>' +
        '            <input type="password" id="user_confirm_password" name="user_password" required>' +
        '            <small class="password-error" readonly></small>   '+
        '            <input type="hidden" id="zelda">'+
        '            <small class="tos_error"></small>   ' +
        '            <input type="submit" value="Register" class="btn-submit">' +
        '        </form>' +
        '    </div>'

    return html;
}

active_newsletters.registration_confirmation = function(){
    html = '' +
        '<i class="close-icon right"></i>' +
        '    <div class="heading">Account Confirmation</div>' +
        '    <div class="newsletter-registration-confirmation">' +
        '        <div class="checkmark"></div>' +
        '        <p>Thank you for registering. You will receive a confirmation email shortly. Please click the confirmation link in that email in order to activate your account.</p> ' +
        '        <p>Then you will be able to login with the email and password you provided.</p>' +
        '    </div>' +
        '   <div class="btn btn-close">Close</div>';

    return html;
}

active_newsletters.active_logged_out_user_register_to_newsletter = function(){
    var $this = this;
    var zelda = '';

    var newsletter_id = $this.clicked_newsletter_id

    var $data = {
        'user_email' : $this.initial_email_used,
        'zelda'     : zelda,
        'newsletter_id' : newsletter_id
    }


    // rcmg_api_call('logged_out_user_subscribing_to_newsletter', $data, function(resp){
    rcmg_api_call('mc_add_guest_member_to_interests', $data, function(resp){
        if(resp.success){

            if(resp.data.mc_responses.status == 'subscribed'){
                active_newsletters.active_item.addClass('subscribed');
                active_newsletters.active_item.find('.icon').empty().addClass('checkmark');
                //toastr.success('You have successfully subscribed to <b>' + active_newsletters.active_item.attr('data-name') + '</b>');
            } else {
                active_newsletters.user_email = $this.initial_email_used;
                active_newsletters.preselect_newsletters = resp.data.newsletters;
                active_newsletters.open_mc_modal();
            }

        }

    });

};

active_newsletters.user_action_options = function(){
    var html = ''

    html += '' +
        '    <i class="close-icon right"></i>' +
        '    <div class="sub-heading success">You have successfully subscribed to '+ active_newsletters.active_item.attr("data-name") +' </div>'+
        '    <div class="heading">Would you like to register a free account with us to manage your subscriptions?</div>' +
        '    <div class="user-options">' +
        '        <div class="btn btn-option register">' +
        '            Register' +
        '        </div>' +
        '        <div class="btn btn-option continue">' +
        '            Next time' +
        '        </div>' +
        '    </div>';

    return html;

};

active_newsletters.signupCloseModal = function(){
    $('.active-subscribe-modal').remove();
    $('.newsletter-signup-modal').remove();
};

active_newsletters.actionTriggers = function(){
    let $this = this;

    $(document).on('click','.close-icon',function(e){
        $this.signupCloseModal();
    });

    /*
    * Newlsetter Signin user form
    * */
    $('.new-newsletter-sign-up-form').submit(function(e){
        e.preventDefault();

        $('.newsletter-signup-modal').addClass('loading');

        let user_email = $('#user_email').val();
        let zelda = $('.zelda').val();

        active_newsletters.initial_email_used = user_email;

        let $data = {
            'user_email' : user_email,
            'zelda'     : zelda,
            'newsletter_id' : active_newsletters.clicked_newsletter_id
        };

        // rcmg_api_call('logged_out_user_subscribing_to_newsletter', $data, function(resp){
        rcmg_api_call('mc_add_guest_member_to_interests', $data, function(resp){
            $('.newsletter-signup-modal').removeClass('loading');

            if(resp.success){
                active_newsletters.active_item.addClass('subscribed');
                active_newsletters.active_item.find('.icon').empty().addClass('checkmark');

                if(resp.data.has_account == 1){ // if user has an account
                    if(resp.data.mc_responses.status == 'subscribed'){
                        $('.newsletter-signup-modal').html(active_newsletters.associated_account_html());

                    } else { // if user is not subscribed show mc modal instead
                        active_newsletters.preselect_newsletters = resp.data.newsletters;
                        active_newsletters.user_email = user_email;
                        active_newsletters.open_mc_modal();
                    }

                }else{
                    // new way to show options
                    if(resp.data.mc_responses.status == 'subscribed'){
                        $('.newsletter-signup-modal').html(active_newsletters.register_account_html());
                    } else { // if user is not subscribed show mc modal instead
                        active_newsletters.preselect_newsletters = resp.data.newsletters;
                        active_newsletters.user_email = user_email;
                        active_newsletters.open_mc_modal();
                    }
                }

            }

        });

    })
    /*
    * Newsletter sign user in form
    * */
    $(document).on('submit', '#newsletter-form-sign-in', function(e){
        e.preventDefault();
        $('.newsletter-signup-modal').addClass('loading');
        $('.sign_in_form_errors').text('');

        var user_email = $('#user_email').val();
        var user_pass = $('#user_password').val();
        var zelda = $('.zelda').val();

        var $data = {
            'email': user_email,
            'password': user_pass,
            'userAgent': navigator.userAgent,
            'WURFL' : window.WURFL,
        };

        var reload_on_login = true;

        rcmg_api_call('form_login', $data, function(response){

            $('.newsletter-signup-modal').removeClass('loading');

            if(response.success){

                rcmg_setLocalCookies(
                    {
                        guid: response.data.rcmg_guid,
                        token: response.data.rcmg_token,
                        username: response.data.rcmg_username,
                        ev_ss: response.data.ev_ss,
                        ex_ss: response.data.ex_ss,
                        accu_weather_loc_key: response.data.accu_weather_loc_key,
                        has_evaf: response.data.has_evaf,
                        rcmg_newsletters: response.data.rcmg_newsletters,
                        is_unsubscribed: response.data.is_unsubscribed,
                        rcmg_product_type: response.data.rcmg_product_type,
                        rcmg_liveramp: response.data.rcmg_liveramp,
                    },
                    reload_on_login
                );
            }else{
                //Error credentials didnt match
                var $error = 'Incorrect password. Please try again';
                $('.sign_in_form_errors').text($error);

            }
        });



    });
    /*
    * Newsletter Register user form
    * */
    $(document).on('submit', '#newsletter-form-register', function(e){
        e.preventDefault();

        $('.newsletter-signup-modal').addClass('loading');

        var full_name = $('#user_full_name').val();
        var user_email = $('#user_email').val();
        var pass = $('#user_password').val();
        var confirm_pass = $('#user_confirm_password').val();
        var zelda = $('#zelda').val();

        var first_last_array = full_name.split(' ');

        var first_name = first_last_array[0];
        var last_name = first_last_array[1];

        var display_name = first_name + "_" + last_name;

        /*
        validation
        * */
        if(zelda != ''){
            /*
            * Thank you but no thank you
            * */
            return false;
        }
        if(pass !== confirm_pass){
            var $error = 'Passwords dont match. Please verify and try again';
            $('.user_confirm_password').text($error);
            return false;
        }


        var data = {
            'user_name' : display_name,
            'user_first_name' : first_name,
            'user_last_name' : last_name,
            'user_password' : pass,
            'user_password_again': confirm_pass,
            'user_email' : user_email,
            'zelda' : zelda
        };


        rcmg_api_call('form_register', data, function(response){

            $('.newsletter-signup-modal').removeClass('loading');

            if(response.success){
                $('.newsletter-signup-modal').html(active_newsletters.registration_confirmation());
            }

        } );

        //toastr.success('Thank you for Registering!');

        return false;

    });

    /*
    options to cloase modal
    * */
    $(document).on('click', '.close-modal', function(e){
        e.preventDefault();

        active_newsletters.signupCloseModal();
    });

    $(document).on('click', '.sign-in-option', function(e){
        e.preventDefault();
        $('.newsletter-signup-modal').html(active_newsletters.associated_account_html());

    });


    $(document).on('change', '#tos_accept',function(e){

        if(this.checked){
            $('.new-newsletter-sign-up-form .btn-submit').attr('disabled', false);
        }else{
            $('.new-newsletter-sign-up-form .btn-submit').attr('disabled', true);
        }
    } );


}

active_newsletters.mc_modal_triggers = function(){
    var close_mc_modal = document.querySelector('[data-close-mc-modal]');
    close_mc_modal.addEventListener('click', function(e){ 
        $('.mc-modal-underlay').hide();
        $('.mc-modal-container').hide();
    });

    active_newsletters.open_mc_modal = function(){
        var mc_input = $('#mc_embed_signup input[type="email"]'); //pass to var, less typing
        if(readCookie('is_unsubscribed') == 'true' && readCookie('rcmg_guid')){
            rcmg_api_call('get_user_newsletters',{
                guid  : getCookie('rcmg_guid'),
                token : getCookie('rcmg_token'),
                userAgent  : navigator.userAgent
            },function(resp){
                if(resp.success){
                    active_newsletters.is_unsubscribed = resp.data.is_unsubscribed;
                    active_newsletters.subscribed = resp.data.newsletters;
                    active_newsletters.preselect_newsletters = resp.data.newsletters; // gets user subscribed newsletters
                    active_newsletters.user_email = resp.data.db_user_info.user_email;
                    active_newsletters.disable_subscribed_newsletters('index-page');
                    mc_input.val(active_newsletters.user_email); //pass email to input

                    $('.mc-modal-underlay').show();
                    $('.mc-modal-container').show();
            
                    if(mc_input.val() != '' || mc_input.val() != undefined || mc_input.val() != null){
                        $('.mc-modal-container .indicates-required').hide();
                        $('.mc-modal-container .mc-field-group.email').hide();
                        $('.mc-modal-container .modal-title-text').hide();
                    }
            
                    active_newsletters.signupCloseModal();
            
                    //fade mouse animation 5 seconds after modal opens
                    setTimeout(function(){
                        $('.mouse_scroll').fadeOut();
                    }, 5000);
                    
                    var array_to_check = [];

                    //loop over newsletters array and store in array_to_check
                    active_newsletters.preselect_newsletters.forEach(function(newsletter){
                        array_to_check.push(newsletter.list_id);
                    });  //end forEach

                    if(array_to_check.indexOf(active_newsletters.clicked_newsletter_id) == -1){ //if the clicked newsletter is not in the array_to_check
                        array_to_check.push(active_newsletters.clicked_newsletter_id); //add it to the array_to_check
                    }
            
                    var mc_newsletters_list = $('.mc-modal-container li input[type="checkbox"]'); //select all newsletters in the modal
                    for (var i = 0; i < mc_newsletters_list.length; i++) { //loop over all newsletters
                        var newsletter_id = mc_newsletters_list[i].getAttribute('data-interest-id'); //get the newsletter id
                        if (mc_user_has_newsletter(newsletter_id)) { //if the user has the newsletter
                           mc_newsletters_list[i].checked = true; //preselect the newsletter 
                        }
                    }
            
                    function mc_user_has_newsletter(newsletter_id){ //check if the user has the newsletter
            
                        for (var i = 0; i < array_to_check.length; i++) { //loop over array_to_check
                            if (newsletter_id == array_to_check[i]) { //if the newsletter_id is in the array_to_check | return true else false
                                return true; 
                            }
                        }
                        return false;
                    }
                };
            });
        } else {
            $('.mc-modal-underlay').show();
            $('.mc-modal-container').show();
            mc_input.val(active_newsletters.user_email); //pass email to input
            if(mc_input.val() != '' || mc_input.val() != undefined || mc_input.val() != null){
                $('.mc-modal-container .indicates-required').hide();
                $('.mc-modal-container .mc-field-group.email').hide();
                $('.mc-modal-container .modal-title-text').hide();
            }

            active_newsletters.signupCloseModal();
            
            //fade mouse animation 5 seconds after modal opens
            setTimeout(function(){
                $('.mouse_scroll').fadeOut();
            }, 5000);

            var array_to_check = [];

            //loop over newsletters array and store in array_to_check
            active_newsletters.preselect_newsletters.forEach(function(newsletter){
                array_to_check.push(newsletter.list_id);
            });  //end forEach

            if(array_to_check.indexOf(active_newsletters.clicked_newsletter_id) == -1){ //if the clicked newsletter is not in the array_to_check
                array_to_check.push(active_newsletters.clicked_newsletter_id); //add it to the array_to_check
            }
    
            var mc_newsletters_list = $('.mc-modal-container li input[type="checkbox"]'); //select all newsletters in the modal
            for (var i = 0; i < mc_newsletters_list.length; i++) { //loop over all newsletters
                var newsletter_id = mc_newsletters_list[i].getAttribute('data-interest-id'); //get the newsletter id
                if (mc_user_has_newsletter(newsletter_id)) { //if the user has the newsletter
                    mc_newsletters_list[i].checked = true; //preselect the newsletter 
                }
            }
    
            function mc_user_has_newsletter(newsletter_id){ //check if the user has the newsletter
    
                for (var i = 0; i < array_to_check.length; i++) { //loop over array_to_check
                    if (newsletter_id == array_to_check[i]) { //if the newsletter_id is in the array_to_check | return true else false
                        return true; 
                    }
                }
                return false;
            }
        }

    }

    var mc_form = $('.mc-modal-container form'); //select the form

    if ( mc_form.length > 0 ) { //if the form exists
        $('.mc-modal-container form input[type="submit"]').bind('click', function ( event ) { // on form submit
            if ( event ) event.preventDefault(); // prevent default form submit
            mc_embedded_subscribe(mc_form,
                function(data){
                    $('.mc-modal-container form input[type="submit"]').attr('disabled', 'disabled');//disable the submit button
                    if (data.result == "success") {
                        $('.mc-modal-container form').hide(); //hide the form
                        $('.mc-modal-container .subscribe_txt').show(); //show message
                        $('.mc-modal-container .mc-modal-preselect-msg').hide(); //hide preselect message
                        active_newsletters.is_unsubscribed = false; //set is_unsubscribed to false
                        deleteCookie('is_unsubscribed');
                        setCookie('is_unsubscribed', active_newsletters.is_unsubscribed, 365);
                        active_newsletters.disable_subscribed_newsletters('beta'); //disable subscribed newsletters
                        
                    } else {
                        $('.mc-modal-container form').hide(); //hide the form
                        $('.mc-modal-container .subscribe_txt span').text("There was an error on our end. Please try again later."); //change the text
                        $( ".mc-modal-container .subscribe_txt" ).addClass( "error" ); //add error class to make text red
                        $('.mc-modal-container .subscribe_txt').show(); //show message
                        $('.mc-modal-container .mc-modal-preselect-msg').hide(); //hide preselect message
                    }
                }
            );
        });
    }

}

active_newsletters.loadNewsletterItemsIndexPage = function(){
    var $html = '<div class="newsletter-flex-layout">';

    $.each(active_newsletters.lists, function (index, value){

        let newsletter_id = value.id;
        if(active_newsletters.debug){
            newsletter_id = value.test_id;
        }

        $html += '<div class="newsletter-item" data-index="'+ index +'" data-name="'+ value.name +'" data-newsletter-id="'+ newsletter_id +'">';
        $html += '<div class="newsletter-image-container">';
        $html += '<div class="bg-image" style="background: url('+ value.image +') no-repeat center center/cover" ></div>';
        $html += '</div>'; /*End of newsletter-image-container*/
        $html += '<div class="newsletter-info">';
        $html += '<div class="icon">+</div>';
        $html += '<div class="newsletter-title">'+ value.name +'</div>';
        $html += '<div class="excerpt">'+ value.excerpt +'</div>';
        $html += '</div>'; /*End of newsletter-info*/
        $html += '</div>';/*End of newsletter-item*/

    });

    $html += '</div>';/*End of newsletter-flex-layout*/

    $('.newsletters_page.newsletter-signup-container2').append($html);

    /*
    * retreaves the newsletter id for what the user has signed up to
    * */

    /*$('.newsletter-item').click(function(e){
        //$(this).hide('slow');

        active_newsletters.active_item = $(this);
        active_newsletters.clicked_newsletter_id = active_newsletters.active_item.attr('data-newsletter-id');
        let nl_name = active_newsletters.active_item.attr('data-name');
        let nl_color = active_newsletters.active_item.attr('data-color');

        if($(this).hasClass('subscribed')){
            toastr.info('You are already subscribed to ' + nl_name);
            return;
        }


        if(!readCookie('rcmg_guid')){

            //will trigger the new signup modal

            if(active_newsletters.initial_email_used != ''){
                //user already entered the email the first time and decided to not login
                active_newsletters.active_logged_out_user_register_to_newsletter();

            }else{
                active_newsletters.signup_modal(nl_name,nl_color);
            }

        }else{
            //user is logged in

            active_newsletters.active_item.addClass('subscribed');

            //Subscribing to newsletter api
            rcmg_api_call('mc_add_logged_in_member_to_interests', {
                'newsletterId' : active_newsletters.active_item.attr('data-newsletter-id'),
                'rcmg_guid' : readCookie('rcmg_guid')
            }, function(resp){

                if(resp.success){
                    if(resp.data.mc_responses.status == 'subscribed'){
                        active_newsletters.active_item.find('.icon').empty().addClass('checkmark');
                        toastr.success("You have successfully subscribed to " + active_newsletters.active_item.attr('data-name') );
                    } else {
                        active_newsletters.open_mc_modal();
                    }
                    
                }
            });

        }

    });*/
}

active_newsletters.get_user_subscribed_newsletters = function(){
    if(readCookie('rcmg_guid')){
        if(readCookie('rcmg_newsletters')){

            if(IsJsonString(readCookie('rcmg_newsletters'))){
                active_newsletters.subscribed = JSON.parse(readCookie('rcmg_newsletters'));
                active_newsletters.disable_subscribed_newsletters('index-page');
            }
        }

    }

}

active_newsletters.disable_subscribed_newsletters = function($location){
    
    if(!active_newsletters.is_unsubscribed) {
        $.each(active_newsletters.subscribed, (index, value) => {

            let list = this.lists.find(list => list.audience_id == value.list_id);

            if($location == 'index-page'){
                $('.newsletter-item[data-newsletter-id=' + value.list_id +'] ').find('.icon').empty().addClass('checkmark');
                $('.newsletter-item[data-newsletter-id=' + value.list_id +']').addClass('subscribed');

                if(list){
                    $('.newsletter-item[data-newsletter-id=' + list.id +'] ').find('.icon').empty().addClass('checkmark');
                    $('.newsletter-item[data-newsletter-id=' + list.id +']').addClass('subscribed');
                    $('.newsletter-item[data-newsletter-id=' + list.test_id +'] ').find('.icon').empty().addClass('checkmark');
                    $('.newsletter-item[data-newsletter-id=' + list.test_id +']').addClass('subscribed');
                }
            }else if($location == 'beta'){
                $('.recommended-newsletter .recommended-item[data-newsletter-id='+ value.list_id + ']').find('.icon').addClass('checkmark');
                $('.recommended-newsletter .recommended-item[data-newsletter-id='+ value.list_id + ']').addClass('subscribed');

                if(list){
                    $('.recommended-newsletter .recommended-item[data-newsletter-id='+ list.id + ']').find('.icon').addClass('checkmark');
                    $('.recommended-newsletter .recommended-item[data-newsletter-id='+ list.id + ']').addClass('subscribed');
                    $('.recommended-newsletter .recommended-item[data-newsletter-id='+ list.test_id + ']').find('.icon').addClass('checkmark');
                    $('.recommended-newsletter .recommended-item[data-newsletter-id='+ list.test_id + ']').addClass('subscribed');
                }
                
            }else if($location == 'article_bottom'){
                    $('.newsletter-recommended .newsletter-item[data-id=' + value.list_id +'] ').find('.icon').empty().addClass('checkmark');
                    $('.newsletter-recommended .newsletter-item[data-id=' + value.list_id +']').addClass('subscribed');
                
            }


            //$(this).find('.icon').empty().addClass('checkmark');

        });
    }
}

active_newsletters.beta_widget_html = function(){
    var $beta_html = '<div class="newsletter-heading">' +
        '<div class="heading">Recommended Newsletters</div> ' +
        '</div>';
    $beta_html += '<div class="recommended-newsletter">';

    $.each(active_newsletters.recommended, function(index, newsletterItem) {

        let newsletter_id = newsletterItem.id;

        if(active_newsletters.debug){
            newsletter_id = newsletterItem.test_id;

        }

        $beta_html += '' +
            '<div class="recommended-item" data-newsletter-id="'+ newsletter_id +'" data-name="'+ newsletterItem.name + '" data-color="'+ newsletterItem.color +'">' +
            '<div class="recommended-image-container">' +
            '<div class="recommended-item-image" style="background: url(' + newsletterItem.image + ') no-repeat center center/cover;" ></div>' +
            '</div>' +
            '<div class="recommended-item-info">' +
            '<i class="icon"></i>'+
            '<div class="recommended-item-title">' + newsletterItem.name + '</div>' +
            '<div class="recommended-excerpt">' + newsletterItem.excerpt + '</div>' +
            '</div>' +
            '</div> ';

    });

    $beta_html += '</div>';

    var $fb_share_html =  '<!--Facebook likes--> ' +
        '       <div class="fb-likes-wrapper">' +
        '           <div class="fb-like" data-href="'+ SITE_INFO['facebook_url'] +'" data-width="" data-layout="button_count" data-action="like"  data-size="small" ></div>' +
        '           <div class="twitter-count-wrapper">'+
        '           <a class="twitter-follow-button"' +
        '              href="'+ SITE_INFO['twitter_url'] +'"' +
        '               data-show-screen-name="false"'+
        '              data-size="small">' +
        '                  Follow</a>' +
        '            </div>'+
        '       </div>';

    var $more_newseltters = '<span class="more-newsletters"><a href="/daily_newsletters/">For More Newsletters Click Here</a></span>';

    return $beta_html + $fb_share_html + $more_newseltters;
}

active_newsletters.display_beta_widget = function(){

    $('.beta .rc-newsletter-widget-new').append(active_newsletters.beta_widget_html());

    if(readCookie('rcmg_guid')){
        
        active_newsletters.beta_logged_in_user_filter_subscribed_newsletters();    
    }

    $('.rc-newsletter-widget-new .recommended-newsletter .recommended-item').click(function (e){
        e.preventDefault();

        active_newsletters.active_item = $(this);
        active_newsletters.clicked_newsletter_id = active_newsletters.active_item.attr('data-newsletter-id');
        let nl_name = active_newsletters.active_item.attr('data-name');
        let nl_color = active_newsletters.active_item.attr('data-color');

        let ga_event_data = {
            'ge_category' : 'Newsletter Signup',
            'ge_noninteraction' : false,
        };
        
        if($(this).hasClass('subscribed')){
            ga_event_data['ge_label'] = "RCP Beta Column Widget - " +  active_newsletters.active_item.attr('data-name');
            ga_event_data['ge_action'] = "User Signup Attempt - Already Subscribed";
            push_ga_event(ga_event_data);
            //toastr.info('You are already subscribed to ' + active_newsletters.active_item.attr('data-name'));
            return;
        }


        if(!readCookie('rcmg_guid')){

            //will trigger the new signup modal

            if(active_newsletters.initial_email_used != ''){
                //user already entered the email the first time and decided to not login
                active_newsletters.active_logged_out_user_register_to_newsletter();
                ga_event_data['ge_label'] = "RCP Beta Column Widget - " +  nl_name;
                ga_event_data['ge_action'] = "User Signup Attempt";
                push_ga_event(ga_event_data);

            }else{
                ga_event_data['ge_label'] = "RCP Beta Column Widget - " +  nl_name;
                ga_event_data['ge_action'] = "User Signup Attempt To First Newsletter";
                push_ga_event(ga_event_data);
                active_newsletters.signup_modal(nl_name,nl_color);
            }

        }else{
            //user is logged in
            active_newsletters.active_item.addClass('subscribed');

            //Subscribing to newsletter api
            rcmg_api_call('mc_add_logged_in_member_to_interests', {
                'newsletterId' : active_newsletters.active_item.attr('data-newsletter-id'),
                'rcmg_guid' : readCookie('rcmg_guid')
            }, function(resp){

                if(resp.success){
                    ga_event_data['ge_label'] = "RCP Beta Column Widget - " +  active_newsletters.active_item.attr('data-name');
                    ga_event_data['ge_action'] = "User Signup Attempt";
                    push_ga_event(ga_event_data);
                    active_newsletters.active_item.find('.icon').empty().addClass('checkmark');
                    //toastr.success("You have successfully subscribed to " + nl_name );

                }
            });

        }


    });
}

/**
 *
 * @param nl_id, optional param passed if a user access an automated newsletter signup url
 * i.e. https://realclearpolitics.com/daily_newsletters?nl=[NewslettersId]
 */
active_newsletters.add_item_to_subscribed_items = function(nl_id){

    if (nl_id===undefined || nl_id === null) {

        let item = {'list_id': active_newsletters.active_item.attr('data-newsletter-id'),'status':'subscribed',"status_boolean":true};
        active_newsletters.subscribed.push(item);
        createCookie('rcmg_newsletters', JSON.stringify(active_newsletters.subscribed), 365);
    }else {

        let item = {'list_id': nl_id,'status':'subscribed',"status_boolean":true};
        active_newsletters.subscribed.push(item);
        createCookie('rcmg_newsletters', JSON.stringify(active_newsletters.subscribed), 365);

    }

}

active_newsletters.recommended_widget_after_full_article = function (){
/*
* Recommended Widget after full article
* */
    if($('.recommended-newsletter').length > 0){

        var $html = '<div class="newsletter-recommended-widget-heading">Recommended Newsletters</div>';
        $html += '<div class="newsletter-recommended">';

        $.each(active_newsletters.recommended, function(index, newsletterItem){

            if(index < 2){ // only show two

                $html += '' +
                    '<div class="recommended-item" data-id="'+ newsletterItem.id +'" data-name="'+ newsletterItem.name + '" data-color="'+ newsletterItem.color +'">' +
                    '<div class="recommended-image-container">' +
                    '<div class="recommended-item-image" style="background: url('+ newsletterItem.image +') no-repeat center center/cover;" ></div>' +
                    '</div>'+
                    '<div class="recommended-item-info">' +
                    '<div class="recommended-item-title">'+ newsletterItem.name +'</div>' +
                    '<div class="recommended-excerpt">'+ newsletterItem.excerpt +'</div>' +
                    '</div>' +
                    '</div> ';
            }

        });

        $html += '</div>';

        $('.recommended-newsletter').append($html);

        $('.recommended-item').click(function (e){
            e.preventDefault();

            active_newsletters.active_item = $(this);
            active_newsletters.clicked_newsletter_id = active_newsletters.active_item.attr('data-id');
            let nl_name = active_newsletters.active_item.attr('data-name');
            let nl_color = active_newsletters.active_item.attr('data-color');

            let ga_event_data = {
                'ge_category' : 'Newsletter Signup',
                'ge_noninteraction' : false,
            };

            if($(this).hasClass('subscribed')){
                ga_event_data['ge_label'] = "After Article Recommended Widget - " +  nl_name;
                ga_event_data['ge_action'] = "User Signup Attempt - Already Subscribed";
                push_ga_event(ga_event_data);
                //toastr.info('You are already subscribed to ' + nl_name);
                return;
            }


            if(!readCookie('rcmg_guid')){

                //will trigger the new signup modal

                if(active_newsletters.initial_email_used != ''){
                    //user already entered the email the first time and decided to not login
                    active_newsletters.active_logged_out_user_register_to_newsletter();
                    ga_event_data['ge_label'] = "After Article Recommended Widget - " +  nl_name;
                    ga_event_data['ge_action'] = "User Signup Attempt";
                    push_ga_event(ga_event_data);

                }else{
                    ga_event_data['ge_label'] = "After Article Recommended Widget - " +  nl_name;
                    ga_event_data['ge_action'] = "User Signup Attempt To First Newsletter";
                    push_ga_event(ga_event_data);
                    active_newsletters.signup_modal(nl_name,nl_color);
                }

            }else{
                //user is logged in
                active_newsletters.active_item.addClass('subscribed');
                //Subscribing to newsletter api
                rcmg_api_call('mc_add_logged_in_member_to_interests', {
                    'newsletterId' : active_newsletters.active_item.attr('data-id'),
                    'rcmg_guid' : readCookie('rcmg_guid')
                }, function(resp){

                    if(resp.success){
                        ga_event_data['ge_label'] = "After Article Recommended Widget - " +  nl_name;
                        ga_event_data['ge_action'] = "User Signup Attempt";
                        push_ga_event(ga_event_data);
                        active_newsletters.active_item.find('.icon').empty().addClass('checkmark');
                        //toastr.success("You have successfully subscribed to " + nl_name );

                    }
                });

            }


        });

    }
}

active_newsletters.highlight_subscribed_newsletters = function(){

    $.each(active_newsletters.lists, function(index, newsletterItem){

        if(newsletterItem.site == active_newsletters.current_site){
            active_newsletters.recommended.push(newsletterItem);
        }

    });
}

function IsJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}


function displayPodcastNewsletter(){

    // var newsletterItemId = 'd6a76c9ec3'; //RCP Takeaway newsletter ite

    var take_away = active_newsletters.lists.find(item => item.name === 'RCP Takeaway');

    $.each(active_newsletters.lists, function(index, newsletterItem){

        if(newsletterItem.id == take_away.id){

            let newsletter_id = newsletterItem.id;
            if(active_newsletters.debug){
                newsletter_id = newsletterItem.test_id;
            }

            var $beta_html = '' +
                '<div class="newsletter-heading">' +
                '<div class="heading">Recommended Newsletters</div> ' +
                '</div>';
            $beta_html += '<div class="recommended-newsletter">';

            $beta_html += '' +
                '<div class="recommended-item" data-id="'+ newsletter_id +'" data-name="'+ newsletterItem.name +  '" data-color="'+ newsletterItem.color +'" >' +
                '<div class="recommended-image-container">' +
                '<div class="recommended-item-image" style="background: url(' + newsletterItem.image + ') no-repeat center center/cover;" ></div>' +
                '</div>' +
                '<div class="recommended-item-info">' +
                '<div class="recommended-item-title">' + newsletterItem.name + '</div>' +
                '<div class="recommended-excerpt">' + newsletterItem.excerpt + '</div>' +
                '</div>' + //end of recmmended-item
                '</div> ';  //end of recommended-newsletter


            $beta_html += '</div>';

            $('.podcast-newsletter').append($beta_html);


            $('.recommended-item').on('click', function(e){
                //window.location = '/daily_newsletters/index.html';
            });

            return;

        }

    });

}

function init_newsletters(){

    $(document).ready(function(){
        
        if(readCookie('is_unsubscribed') == 'true' && readCookie('rcmg_guid')){
            active_newsletters.is_unsubscribed = true;
        }

        if($('body').hasClass('home')){
            active_newsletters.beta_widget_enabled = true;
            active_newsletters.highlight_subscribed_newsletters();
            
            if(active_newsletters.beta_widget_enabled){
                active_newsletters.display_beta_widget();
            }
        }
    
        if($('body').hasClass('index-newsletters')){
    
            active_newsletters.loadNewsletterItemsIndexPage();
            active_newsletters.get_user_subscribed_newsletters();
        }
    
        if($('body').hasClass('article')){
            
            active_newsletters.beta_widget_enabled = true;
            
            active_newsletters.highlight_subscribed_newsletters();
            active_newsletters.recommended_widget_after_full_article();
            active_newsletters.disable_subscribed_newsletters('article_bottom');
            
            /*
            This Only needs to be triggered in the article permalink
            * */
            if(!$('body').hasClass('distro-layout')){
                active_newsletters.highlight_subscribed_newsletters();
            }
    
            if(active_newsletters.beta_widget_enabled){
                active_newsletters.display_beta_widget();
            }
        }

        if($('body').hasClass('author')) {
            active_newsletters.beta_widget_enabled = true;
            active_newsletters.highlight_subscribed_newsletters();

            if(active_newsletters.beta_widget_enabled){
                active_newsletters.display_beta_widget();
            }
        }
    
        if($('body').hasClass('podcast-landing')){
            displayPodcastNewsletter();
    
        }
    
    
    });
}

(active_newsletters.create_mc_modal = function(){
    //create modal container
    //to add a new newsletter to the list you need to go to mailchimp
    //and and click on "Audience" and then "Signup forms"
    //select embedded forms and do as if you were adding a form 
    //get to the step where you see the the embed code and get the data from there
    var modal_container = $(
    '   <div class="mc-modal-underlay"></div>'+
    '   <div class="mc-modal-container">'+
    '       <div class="modal-content">'+
    '           <div class="modal-header">'+
    '               <div class="modal-title">'+
    '                   <div class="modal-title-text"><h3>Enter your email address to subscribe</h3></div>'+
    '               </div>'+
    '               <div class="modal-close">'+
    '                   <div data-close-mc-modal class="close-icon right"></div>'+
    '               </div>'+
    '           </div>'+
    '           <div class="modal-body">'+
    '               <div class="mc-modal-preselect-msg">We preselected all newsletters you had before unsubscribing.</div>' +
    '               <div class="modal-body-text">'+
    '                   <!-- Begin Mailchimp Signup Form --> '+
    '                   <div id="mc_embed_signup"> '+
    '                       <form action="https://realclearpolitics.us7.list-manage.com/subscribe/post?u=61572bb8acf7b8704903af7b8&amp;id=036f88a1e3" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate> '+
    '                           <div id="mc_embed_signup_scroll"> '+
    '                           <div class="indicates-required"><span class="asterisk">*</span> indicates required</div> '+
    '                           <div class="mc-field-group email"> '+
    '                               <label for="mce-EMAIL">Email Address  <span class="asterisk">*</span> '+
    '                               </label> '+
    '                               <input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL"> '+
    '                           </div> '+
    '                           <div class="mc-field-group input-group"> '+
    '                               <strong>Newsletters </strong> '+
    '                               <ul> '+
    '                                   <li><input data-interest-id="0978b16ed7" type="checkbox" value="2" name="group[5973][2]" id="mce-group[5973]-5973-1"><label for="mce-group[5973]-5973-1">RCP Today</label></li> '+
    '                                   <li><input data-interest-id="b6df7a5a47" type="checkbox" value="1" name="group[5973][1]" id="mce-group[5973]-5973-0"><label for="mce-group[5973]-5973-0">Carl M. Cannon\'s Morning Note</label></li> '+
    '                                   <li><input data-interest-id="b0e1454bd9" type="checkbox" value="4" name="group[5973][4]" id="mce-group[5973]-5973-2"><label for="mce-group[5973]-5973-2">RCP Takeaway</label></li> '+
    '                                   <li><input data-interest-id="17b0333591" type="checkbox" value="8" name="group[5973][8]" id="mce-group[5973]-5973-3"><label for="mce-group[5973]-5973-3">RCP Events</label></li> '+
    '                                   <li><input data-interest-id="4be11a1ba6" type="checkbox" value="16" name="group[5973][16]" id="mce-group[5973]-5973-4"><label for="mce-group[5973]-5973-4">Defense Morning Recon</label></li> '+
    '                                   <li><input data-interest-id="7c94a2a355" type="checkbox" value="32" name="group[5973][32]" id="mce-group[5973]-5973-5"><label for="mce-group[5973]-5973-5">Science News</label></li> '+
    '                                   <li><input data-interest-id="698c52111c" type="checkbox" value="64" name="group[5973][64]" id="mce-group[5973]-5973-6"><label for="mce-group[5973]-5973-6">Energy Morning Volt</label></li> '+
    '                                   <li><input data-interest-id="131071d6c4" type="checkbox" value="128" name="group[5973][128]" id="mce-group[5973]-5973-7"><label for="mce-group[5973]-5973-7">World News</label></li> '+
    '                                   <li><input data-interest-id="a957e8b6b1" type="checkbox" value="256" name="group[5973][256]" id="mce-group[5973]-5973-8"><label for="mce-group[5973]-5973-8">Education Today</label></li> '+
    '                                   <li><input data-interest-id="834d157b5f" type="checkbox" value="512" name="group[5973][512]" id="mce-group[5973]-5973-9"><label for="mce-group[5973]-5973-9">Health Morning Scan</label></li> '+
    '                                   <li><input data-interest-id="49df3ce58e" type="checkbox" value="1024" name="group[5973][1024]" id="mce-group[5973]-5973-10"><label for="mce-group[5973]-5973-10">Policy</label></li> '+
    '                                   <li><input data-interest-id="b54e369263" type="checkbox" value="2048" name="group[5973][2048]" id="mce-group[5973]-5973-11"><label for="mce-group[5973]-5973-11">Religion Today</label></li> '+
    '                                   <li><input data-interest-id="e1222b54d5" type="checkbox" value="4096" name="group[5973][4096]" id="mce-group[5973]-5973-12"><label for="mce-group[5973]-5973-12">Books Today</label></li> '+
    '                                   <li><input data-interest-id="75efb6c7ae" type="checkbox" value="8192" name="group[5973][8192]" id="mce-group[5973]-5973-13"><label for="mce-group[5973]-5973-13">History Today</label></li> '+
    '                                   <li><input data-interest-id="81822f7ea3" type="checkbox" value="16384" name="group[5973][16384]" id="mce-group[5973]-5973-14"><label for="mce-group[5973]-5973-14">Markets Today</label></li> '+
    '                                   <li><input data-interest-id="6352181190" type="checkbox" value="32768" name="group[5973][32768]" id="mce-group[5973]-5973-15"><label for="mce-group[5973]-5973-15">Investigations Today</label></li> '+
    '                                   <li><input data-interest-id="dfbbf01030" type="checkbox" value="65536" name="group[5973][65536]" id="mce-group[5973]-5973-16"><label for="mce-group[5973]-5973-16">Public Affairs Energy Realism</label></li> '+
    '                                   <li><input data-interest-id="aa91b5c3b2" type="checkbox" value="131072" name="group[5973][131072]" id="mce-group[5973]-5973-17"><label for="mce-group[5973]-5973-17">Public Affairs American Civics</label></li> '+
    '                                   <li><input data-interest-id="3aba243860" type="checkbox" value="262144" name="group[5973][262144]" id="mce-group[5973]-5973-18"><label for="mce-group[5973]-5973-18">Public Affairs Reimagining Healthcare</label></li> '+
    '                                   <li><input data-interest-id="b64a8082f3" type="checkbox" value="524288" name="group[5973][524288]" id="mce-group[5973]-5973-19"><label for="mce-group[5973]-5973-19">RealClear Pennsylvania</label></li> '+
    '                                   <li><input data-interest-id="839e6a4969" type="checkbox" value="2097152" name="group[5973][2097152]" id="mce-group[5973]-5973-20"><label for="mce-group[5973]-5973-20">Public Affairs Trustworthy Elections</label></li> '+
    '                                   <li><input data-interest-id="6aa7d6bdec" type="checkbox" value="4194304" name="group[5973][4194304]" id="mce-group[5973]-5973-21"><label for="mce-group[5973]-5973-21">Public Affairs Grand Strategy</label></li> '+
    '                                   <li><input data-interest-id="98754a303f" type="checkbox" value="8388608" name="group[5973][8388608]" id="mce-group[5973]-5973-22"><label for="mce-group[5973]-5973-22">RealClear Florida</label></li> '+
    '                               </ul> '+
    '                           </div> '+
    '                           <div class="mouse_scroll"> '+
    '                               <div class="mouse"> '+
    '                                   <div class="wheel"></div> '+
    '                               </div> '+
    '                               <div> '+
    '                                   <span class="m_scroll_arrows one"></span> '+
    '                                   <span class="m_scroll_arrows two"></span> '+
    '                                   <span class="m_scroll_arrows three"></span> '+
    '                               </div> '+
    '                           </div> '+
    '                           <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_61572bb8acf7b8704903af7b8_036f88a1e3" tabindex="-1" value=""></div> '+ //real people should not fill this in and expect good things - do not remove this or risk form bot signups
    '                           <div class="clear"><input data-submit-mc-form type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button btn btn-submit"></div> '+
    '                           </div> '+
    '                       </form> '+
    '                       <div class="subscribe_txt" style="display:none">'+
    '                           <span>Thanks for Subscribing!</span> '+
    '                       </div> '+
    '                   </div> '+
    '                   <!--End mc_embed_signu</link>p--> '+
    '               </div>'+
    '           </div>'+
    '       </div>'+
    '   </div>'
    );
    $('body').append(modal_container);
    active_newsletters.mc_modal_has_been_created = true; //set to true so that the modal is not created again
    active_newsletters.mc_modal_triggers(); // calls functionality for mc modal
}());

function push_ga_event(data){
    let tracking_code = '';

    try{
        if(SITE_INFO['global_site_url'] == 'https://www.realclearpolitics.com'){
            tracking_code = SITE_INFO['google_analytics_id'];
            console.log("rcp",tracking_code);
        }else {
            tracking_code = SITE_INFO['google_analytics_tracking_code'];
            console.log("ms",tracking_code);
        }
        _gaq.push(['_setAccount', tracking_code]);
        _gaq.push(['_setDomainName', SITE_INFO['global_site_url'].replace('https://www.','')]);
        _gaq.push(['_trackEvent', data['ge_category'], data['ge_action'], data['ge_label'], 0, data['ge_noninteraction']]);
        console.log('_track_event: '+ data['ge_category'] + ' ' + data['ge_action'] + ' ' + data['ge_label'] + ' ' + data['ge_noninteraction']);
    } catch(err) {}
}

export default init_newsletters;